<div class="welcome-container">
  <img src="/assets/images/LynnCo-Logo-Full-Color.png" alt="Lynnco Logo" class="logo-fade-in" />
  <h2>Welcome to LynnCo BI</h2>
</div>
